import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 2,
  class: "app-input__date-wrapper"
}
const _hoisted_3 = ["id", "name", "value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "app-input__description" }, "Day", -1)
const _hoisted_5 = ["id", "name", "value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "app-input__description" }, "Month", -1)
const _hoisted_7 = ["id", "name", "value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "app-input__description" }, "Year", -1)
const _hoisted_9 = ["id", "name", "type", "placeholder"]
const _hoisted_10 = {
  key: 4,
  class: "perform-search-loading"
}
const _hoisted_11 = {
  key: 5,
  class: "app-input__msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppLoadingIcon = _resolveComponent("AppLoadingIcon")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-input", { 'app-input--error': _ctx.error, 'app-input--has-icon': _ctx.icon, 'app-input--date' : _ctx.type === 'date'}])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id
        }, _toDisplayString(_ctx.label), 9, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.icon)
      ? (_openBlock(), _createBlock(_component_AppIcon, {
          key: 1,
          name: _ctx.icon
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    (_ctx.type === 'date')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              id: `${_ctx.id}-day`,
              name: _ctx.id,
              maxlength: 2,
              placeholder: "DD",
              value: _ctx.date.day,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateDateFields('day', $event.target.value)))
            }, null, 40, _hoisted_3),
            _hoisted_4
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              id: `${_ctx.id}-month`,
              name: _ctx.id,
              maxlength: 2,
              placeholder: "MM",
              value: _ctx.date.month,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateDateFields('month', $event.target.value)))
            }, null, 40, _hoisted_5),
            _hoisted_6
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              id: `${_ctx.id}-year`,
              name: _ctx.id,
              maxlength: 4,
              placeholder: "YYYY",
              value: _ctx.date.year,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateDateFields('year', $event.target.value)))
            }, null, 40, _hoisted_7),
            _hoisted_8
          ])
        ]))
      : _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
          key: 3,
          id: _ctx.id,
          name: _ctx.id,
          type: _ctx.type,
          placeholder: _ctx.placeholderText
        }, _ctx.$attrs, {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValue) = $event)),
          onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('focus', $event.target.value))),
          onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('blur', $event.target.value)))
        }), null, 16, _hoisted_9)), [
          [_vModelDynamic, _ctx.inputValue],
          [_directive_focus, _ctx.autofocus]
        ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_AppLoadingIcon, { height: "20" })
        ]))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(typeof _ctx.error === 'string' ? _ctx.error : ''), 1))
      : _createCommentVNode("", true)
  ], 2))
}